import React from 'react';

const Web3Techniques = () => {
  return (
    <>
      {/* Web3-Specific Prompt Techniques */}
      <h3 className="text-2xl font-bold text-gray-800 mb-6">Web3-Specific Prompt Techniques</h3>
      
      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">DeFi Protocol Integration</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          When working with DeFi protocols, structure your prompts to include:
        </p>
        <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h5 className="font-semibold text-red-600 mb-2">❌ Vague approach:</h5>
              <div className="bg-red-50 p-3 rounded border border-red-200">
                <code className="text-sm text-gray-800">Interact with Uniswap to swap tokens</code>
              </div>
            </div>
            <div>
              <h5 className="font-semibold text-green-600 mb-2">✅ Structured approach:</h5>
              <div className="bg-green-50 p-3 rounded border border-green-200">
                <code className="text-sm text-gray-800">Integrate with Uniswap V3 to execute token swaps. Consider: 1) Pool liquidity depth, 2) Price impact analysis, 3) Slippage tolerance (max 1%), 4) Gas optimization, 5) MEV protection strategies. Validate pool addresses and token contracts before execution.</code>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Smart Contract Interaction Patterns</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          For smart contract operations, provide comprehensive context:
        </p>
        <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-4">
          <ul className="space-y-2 text-gray-700">
            <li>• Contract addresses and verification status</li>
            <li>• Function signatures and parameter types</li>
            <li>• Gas estimation and optimization requirements</li>
            <li>• Error handling and transaction failure scenarios</li>
            <li>• Event monitoring and state validation</li>
          </ul>
        </div>
      </div>

      <div className="mb-8">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Protocol Coordination</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          For multi-protocol operations, specify the coordination logic:
        </p>
        <div className="bg-purple-50 p-6 rounded-lg border border-purple-200 mb-4">
          <div className="text-sm text-gray-800 bg-white p-4 rounded border">
            <strong>Example prompt structure:</strong><br/>
            "Execute arbitrage between Uniswap and SushiSwap:<br/>
            1. Monitor price differences for USDC across both DEXs<br/>
            2. When spread exceeds 0.1%, initiate arbitrage sequence<br/>
            3. Execute simultaneous buy/sell operations<br/>
            4. Account for slippage and gas costs in profitability calculation<br/>
            5. Implement timeout mechanisms if execution exceeds 2 minutes"
          </div>
        </div>
      </div>

      <div className="mb-12">
        <h4 className="text-xl font-semibold text-gray-800 mb-4">Autonomous Agent Communication</h4>
        <p className="text-gray-700 leading-relaxed mb-4">
          For agent-to-agent interactions in decentralized systems:
        </p>
        <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-4">
          <ul className="space-y-2 text-gray-700">
            <li>• Define message protocols and data formats</li>
            <li>• Establish trust verification mechanisms</li>
            <li>• Specify consensus requirements for multi-agent decisions</li>
            <li>• Include dispute resolution and rollback procedures</li>
            <li>• Set communication timeouts and fallback strategies</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Web3Techniques;
